var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"main-alert",attrs:{"border":"right","type":_vm.tipo,"text":"","outlined":"","dense":"","icon":_vm.icon}},[_vm._t("default",function(){return [_vm._v("Não encontramos resultados para este recurso.")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }